import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import {ProcedureComponent} from './procedure/procedure.component';
import {Observable} from 'rxjs';
import {PrimusRouterService} from '../core/primus-router.service';

@Injectable()
export class CanDeactivateProcedurePage  {
  constructor(private primusRouter: PrimusRouterService) {
  }

  canDeactivate(
    component: ProcedureComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.primusRouter.checkCancel();
  }
}
